import { apiClient } from "./apiClient";

export default {
  getById(id) {
    return apiClient.get("/rest/wifi_cellular_mismatch/" + id);
  },

  getByIds(params) {
    return apiClient.post(
      `/rest/wifi_cellular_mismatch/byIds`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  delete(id, deleteAll = false, addToPrivate = false) {
    return apiClient.delete(`/rest/wifi_cellular_mismatch/${id}`, {
      params: {
        deleteAll: deleteAll,
        addToPrivate: addToPrivate,
      },
    });
  },

  createPrivateCellularTower(id, location) {
    return apiClient.post(
      `/rest/wifi_cellular_mismatch/private_cell_towers/${id}`,
      location
    );
  },

  deletePrivateCellularTower(id) {
    return apiClient.delete(
      `/rest/wifi_cellular_mismatch/private_cell_towers/${id}`
    );
  },
};
